import * as React from "react";
import PropTypes from "prop-types";
import {isMobile} from 'react-device-detect';
import { raiseGAEvent, GA_EVENTS } from '../analytics';

class ClosestStoreComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStore: false
    };
  }

  handleShowStoreDetails = () => {
    this.setState({
      selectedStore: !this.state.selectedStore,
    });
  }

  formatDistance(distance, units) {
    return `${Number(distance).toFixed(2)} ${units}`;
  }

  getCardColorStyle = () => {
    let cardColor;
    const { inStock, lowStock, outOfStock } = this.props;

    if (inStock && inStock.length > 0) {
      cardColor = 'bbnt-findinstore-closest-stores__card__color--in-stock';
    } 
    else if (lowStock && lowStock.length > 0) {
      cardColor = 'bbnt-findinstore-closest-stores__card__color--low-stock';
    } 
    else if (outOfStock && outOfStock.length > 0) {
      cardColor = 'bbnt-findinstore-closest-stores__card__color--out-of-stock';
    }

    return cardColor;
  }

  getProductLabels(skuIds) {
    if (skuIds && skuIds.length > 0) {
      const { products } = this.props;
      const labels = {};
      products.forEach((i) => (labels[i.product_sku] = i.product_item_list_desc));
      return skuIds.map((i) => labels[i]).join(', ');
    }

    return [];
  }
  
  openMap = (lat, lng) => {
      let url = `https://maps.google.com/?q=${lat},${lng}`;
      raiseGAEvent(GA_EVENTS.CLICK_VIEW_MAP, url);
      window.open(url, '_blank');
  }
  
  renderOpeningHours = (opening_hours, name) => {
    if(name.indexOf("Temporarily Closed") > -1){
      return "Temporarily Closed"
    } else {
      let rows = [];
      opening_hours.split('\n').map((item, i) => {
         rows.push(<p key={i}>{item}</p>);
      })
      return rows;
    }
  }

  render() {
    const { data, inStock, lowStock, outOfStock } = this.props;
    const { distance, units, phone, street, opening_hours, latitude, longitude } = data;
    const { selectedStore } = this.state;

    let openingHoursFontColor = (data.name.indexOf("Temporarily Closed") > -1) ? "red" : "#6b6c70";
    
    let icon = (
      <span>{(selectedStore) 
              ? <i className = "hide-store-icon store-icon-setting"></i> 
              : <i className = "view-store-icon store-icon-setting"></i>}</span>
    );
    const cardColorStyle = this.getCardColorStyle();

    return (
      <div className={`card ${cardColorStyle}`} onClick={this.handleShowStoreDetails}>
        <div className="card-title">
          <div>
            <span className='card-title-city'>{data.name}&nbsp;</span>
            <span className="distance">
              {" "}
              {this.formatDistance(distance, units)}
            </span>
          </div>
          {!isMobile &&
            <div className="link-label">
              <span>
                {icon}
                {selectedStore ? " Hide Store Details" : " View Store Details"}
              </span>
            </div>
          }
        </div>
        <div className="card-details">
          <div className='stock-availability-row'>
            {inStock && inStock.length > 0 && (
              <span className="available">
                <i className = "in-stock-icon store-icon-setting"></i>
                In Stock: <span>{this.getProductLabels(inStock)}</span>
              </span>
            )}
          </div>
          <div className='stock-availability-row'>
            {lowStock && lowStock.length > 0 && (
              <span className="low-stock">
                <i className = "low-stock-icon store-icon-setting"></i>
                Low Stock:{" "}
                <span>{this.getProductLabels(lowStock)}</span>
              </span>
            )}
          </div>
          <div className='stock-availability-row'>
            {outOfStock && outOfStock.length > 0 && (
              <span className="not-available">
                <i className = "out-stock-icon store-icon-setting"></i>
                Out of Stock:{" "}
                <span>{this.getProductLabels(outOfStock)}</span>
              </span>
            )}
          </div>
          {isMobile &&
            <div className="link-label">
              <span>
                {icon}
                {selectedStore ? " Hide Store Details" : " View Store Details"}
              </span>
            </div>
          }
          <div>
            {selectedStore && (
              <div>
              {// google analytics event for Click View Store Details
                raiseGAEvent(GA_EVENTS.CLICK_VIEW_STORE_DETAILS, data.name)
              }
                <hr className='store-details-devider' />
                <div className="sections">
                  <div className="sec-1">
                    <div className="sub-title">Phone</div>
                    <div className="details store-detail-phone">{phone}</div>
                    <div className="sub-title address">Address</div>
                    <div className="details">{street}</div>
                    <br/>
                    <div className="map" onClick={() => this.openMap(latitude, longitude)}><span className='view-map-link'>&#128681; View Map</span></div>
                  </div>
                  <div className="sec-2">
                    <div className="sub-title">Opening Hours</div>
                    <div className="details" style={{ color: openingHoursFontColor}}>{this.renderOpeningHours(opening_hours, data.name)}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ClosestStoreComponent.propTypes = {
  products: PropTypes.array.isRequired
};

export default ClosestStoreComponent;
